const PLAYWRIGHT_TEST_IDS = {
	TOP_BAR_USER: "playwright-top-bar-user",
	HOME_CLOCK_FACE: "playwright-home-building-clock",
	HOME_LEFT_MARQUEE: "playwright-home-left-marquee",
	HOME_RIGHT_MARQUEE: "playwright-home-right-marquee",
	LEVEL_PROGRESS_BAR: "playwright-level-progress-bar",
	DEBUG_GET_STARS_: "playwright-debug-get-stars-",
	TEST_SUMMARY_BUTTON: "playwright-test-summary-button",
	BLUE_BUTTON: "playwright-blue-button",
};

module.exports = {PLAYWRIGHT_TEST_IDS};
